import React, { Component } from "react";
import { connect } from "react-redux";

import {
    toggleNoticeModal
} from "../../modules/hiclasstv";

import UserInfoContainer from "../user/UserInfoContainer";

import WebHeader from "../../components/etc/WebHeader";
import WebHeaderLandingTemplate from "../../components/etc/WebHeaderLandingTemplate";   // 20261105 디자이너 헤더 틀
import ConstData from "../../lib/ConstData";   // 20261105 USE_LANDING_HTML 확인용

class WebHeaderTitleContainer extends Component {

    handleSelectedFunc = ({ selectedFunc }) => {
        switch (selectedFunc) {
            case "REFRESH_HOME":
                this.props.toggleNoticeModal({ status: true });
                break;

            default:
                break;
        }
    }

    render() {
        // 20261105 로고/메뉴 영역은 기존 컴포넌트 그대로 사용 (디자이너 헤더 틀의 슬롯에도 같은 컴포넌트를 넣음)
        const logo = (
            <WebHeader
                userKind={this.props.userKind}
                isLoginYn={this.props.isLoginYn}
                handleSelectedFunc={this.handleSelectedFunc}
            />
        );

        const menu = (
            <UserInfoContainer
                isLoginYn={this.props.isLoginYn}
                routeProps={this.props.routeProps}
                currentPageType={this.props.currentPageType}
                currentManagePageType={this.props.currentManagePageType}
                goToAloneChatting={this.props.goToAloneChatting}
            />
        );

        // 기존 헤더 (디자이너 헤더 틀을 쓰지 않거나 읽지 못할 때)
        const originalHeader = (
            <div className="d-flex flex-column w-100">
                <div className="header-title">
                    {logo}
                </div>
                <div className="header-menu">
                    {menu}
                </div>
            </div>
        );

        // 20261105 USE_LANDING_HTML 이면 디자이너 헤더 틀({landing}/header.js) 사용, 실패 시 기존 헤더
        if (ConstData.USE_LANDING_HTML) {
            return (
                <WebHeaderLandingTemplate
                    logo={logo}
                    menu={menu}
                    fallback={originalHeader}
                    isLoginYn={this.props.isLoginYn}    // 20261105 로그인 전/후 구분 (data-hc-login)
                />
            );
        }

        return originalHeader;
    }
}

export default connect(
    ({ user }) => ({
        userKind        : user.userKind,
        isLoginYn       : user.isLoginYn
    }),
    {
        toggleNoticeModal
    }
)(WebHeaderTitleContainer);